<template>
    <div class="analysis-details"> 
        <div class="details-info"> 
            <div class="info-analysis  "> 
                <div>
                    <b>支持度 </b>0.01
                    <b>置信度 </b>0.01 
                </div>
                 
            </div>
            <!-- <loadModel v-show='isLoad'></loadModel> -->
            <div v-show='!isLoad'>
                <div v-show="tableListAll.length!=0" class="info-relevance" id="d3DIV" ref='d3Info'>
                    <RelationGraph  ref="seeksRelationGraph" :options="graphOptions" :on-node-click="onNodeClick" :on-line-click="onLineClick" />
                </div>
                <div >
                    <el-table
                        class="details-table"
                        :data='tableList'
                        :header-cell-style="{background:'#409EFF',color:'#fff'}"
                        row-key="id"
                        border
                        default-expand-all
                        @sort-change="sort_change">
                        <el-table-column
                            label="NO"
                            sortable
                            width="90px"
                            align="center"
                            prop="num"
                        >
                        </el-table-column>
                        <el-table-column
                            align="center"
                            sortable
                            prop="source"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            sortable
                            prop="target"
                            label="名称">
                        </el-table-column>
                        <el-table-column
                            label="支持度"
                            sortable
                            align="center"
                            prop="support"
                            width="160"
                        >
                            <!-- <template slot-scope="scope">
                                <p>{{Number(scope.row.support).toFixed(3)}}</p>
                            </template> -->
                        </el-table-column>
                        <el-table-column
                            align="center"
                            sortable
                            prop="confidence"
                            label="置信度">
                        </el-table-column>
                        <!-- 2024 12 26版本bug修改要求隐藏 -->
                        <!-- <el-table-column
                            align="center"
                            sortable
                            prop="coverage"
                            width="160"
                            label="覆盖量">
                        </el-table-column> -->
                        <el-table-column
                            align="center"
                            sortable
                            prop="lift"
                            label="提升度">
                        </el-table-column>
                        <el-table-column
                            align="center"
                            sortable
                            prop="count"
                            label="共现度">
                        </el-table-column>
                    </el-table>
                    <el-pagination 
                        size='small'
                        class="page-wrap"  
                        @current-change="changePage" 
                        background
                        :current-page="pageInfo.pageNum" 
                        :page-count="pageInfo.pageTotal" 
                        :page-size="pageInfo.pageSize"
                        :page-sizes="[10, 20, 30, 50, 100]"
                        :total="pageInfo.total"
                        layout="total, prev, pager, next, jumper" >
                    </el-pagination>
                </div>
            </div>
            
        </div>
        
        <modelTip :ok="'确定'"  :show.sync='isNoData' @ok='sureTip' :width="'450px'" :title="'提示'">
            <div slot="content" >
                <p>暂无相关分析数据～</p>
            </div>
        </modelTip>
    </div>
</template>

<script>
import domtoimage from 'dom-to-image';
import html2Canvas from 'html2canvas' 
import modelTip from "../../../components/ui-kit/model_tip.vue"
// import {apriori_gl} from "../../../io/api.js"
import RelationGraph from 'relation-graph' 
import subjectData from './subjectData.js'
// import d3Info  from '../comps/d3.vue'
export default {
    props: ['tableListAll'],
    components: {
        RelationGraph, 
        modelTip, 
    },
    data () {
        return {
            labelWidth:'90px',
            searchType:'HERB',
            searchRadio:[
                {
                    value:'中药',
                    label:'HERB'
                },
                {
                    value:'症状',
                    label:'SYMP'
                },
            ],
            beforeValue:this.$route.query.beforeValue||'',
            afterValue:this.$route.query.afterValue||'',
            optionLable:this.$route.query.optionLable||'',
            believeValue:'0.5', 
            supportValue:'0.1',
            jiaoYao:'1',  
            isLoad:false,
            tableList:[],
            isNoData:false,
            // tableListAll:subjectData.relevanceList,
            pageInfo: {
                pageNum: 1,
                pageTotal: 1,
                total: 1,
                pageSize: 10,
            },
            isShowReport:false,
            reportName:'',
            // 图谱相关配置
            graphOptions: { 
                defaultNodeColor: 'rgba(238, 178, 94, 1)',
                allowSwitchLineShape: true,//是否在工具栏中显示切换线条形状的按钮
                allowSwitchJunctionPoint: true,//是否在工具栏中显示切换连接点位置的按钮
                backgrounImageNoRepeat: true,
                defaultNodeBorderWidth: 4, //默认的节点边框粗细（像素）
                defaultNodeBorderColor: "rgb(198, 201, 176)",//默认的节点边框颜色
                checkedLineColor: "#ddd", //当线条被选中时的颜色
                downloadImageFileName:'关联分析结果图',//图片的名称   
                placeOtherGroup: true,//支持展示多个关系网
                placeSingleNode: true,//自动为孤点分配位置
                defaultLineMarker : { 
                    refX: "0",
                    refY: "0", 
                    isHideArrow:false,
                },  
                layouts: [
                    { 
                        layoutName: 'center',//force center
                        layoutClassName: 'seeks-layout-center',
                        defaultNodeShape: 0,  //默认的节点形状，0:圆形；1:矩形
                        distance_coefficient:1//层级距离系数，默认为1，可以为小数，用于调节中心布局不同层级之间的距离，实现连线比较长的视觉效果使用示例
                    }
                ],
                defaultJunctionPoint: 'border'
            },
            linkArr:[],
            nodes:[],
            scale:'',
            reportImg:'',
        }
    },
    watch: {
        tableListAll(val,old){
            // console.log(val,'===setData')
            this.setData()
        }  
    },
    mounted () {
        this.getInfo(); 
    },
    methods: {
        getInfo(){
            let attNa= `${this.beforeValue}—${this.afterValue}`;
            let param={
                attNa,
                attrNames:this.optionLable,//
                support:this.supportValue,//支持度
                confidence:this.believeValue,//可信度
                jiaoYao:this.jiaoYao,//有无角药
            }
            // this.isLoad=true;
            this.setData()
            // apriori_gl(param).then(res=>{
            //     let data = res.data;
            //     if(data&&data.code==0){
            //         this.setData(data.data.data)
            //     }else{
            //         this.$message.error(data.msg||'请求失败～')
            //     }
            //     this.isLoad = false;
            // })
            
        },
        // 数据处理
        setData(data){
            let sourceAll=[]
            let targetAll=[]
            // this.tableListAll = [].concat(data);
            this.pageInfo.total=this.tableListAll.length;
            this.pageInfo.pageTotal = Math.ceil(this.pageInfo.total/10);
            this.changePage(1);
            this.linkArr=[];
            this.nodes=[];
            // 重新组合数据
            this.tableListAll&&this.tableListAll.forEach((item,index)=>{
                item.num = index+1;
                let obj = {
                    from: '', 
                    to: '',
                    text:'',
                    // color:'#A5AC77'
                } 
                obj.from = item.source;
                obj.to = item.target;
                obj.text =item.count;
                obj.lineWidth=1;
                // 防止to找不到from的情况，重新组成数据
                let sourceObj={
                    source:item.source,
                    count:item.count,
                }
                let targetObj={
                    source:item.target,
                    count:item.count,
                }
                sourceAll.push(sourceObj)
                targetAll.push(targetObj)
                this.linkArr.push(obj)
 
                // 去除from=to&&to==from的
                this.linkArr.forEach((item,index)=>{
                    if(item.from==obj.to&&item.to==obj.from){ 
                        this.linkArr.splice(index,1)
                    }
                     
                })  
            }) 
            //处理to不到from的情况，合并数组并去重
            let arrAll =[...sourceAll,...targetAll]
            let newArr =  [...new Set(arrAll)];
            const map = new Map();
            const nodeArr = newArr.filter(v => !map.has(v.source) && map.set(v.source, 1));
            // 根据合并后的数据处理成符合图谱的数据
            nodeArr.forEach(item=>{
                let nodeObj={
                    id:'',
                    text:'',
                    color:'#A5AC77',  
                    fontColor: '#000', 
                } 
                nodeObj.id = item.source;
                nodeObj.text = item.source; 
                this.nodes.push(nodeObj);
            }) 
            // console.log(this.tableListAll.length,'===this.tableListAll.length',this.nodes,this.lines)
            this.$nextTick(()=>{
                if(this.tableListAll.length!=0){
                    this.showSeeksGraph()
                }else{
                    this.isNoData = true 
                }
            })
            
        },
        sureTip(){
            this.isNoData = false;
        },
        go_back(){
            this.$router.push({
                path:'excavate',
                query:{
                    navType:5,
                }
            }) 
        },
        // table排序
        changePage(num) {
            this.pageInfo.pageNum = num;
            this.tableList= this.tableListAll.slice((this.pageInfo.pageNum-1)*this.pageInfo.pageSize,this.pageInfo.pageNum*this.pageInfo.pageSize);
            // }
        },
        sort_change(column) { // column是个形参，具体查看element-ui文档
            this.column = column;
            this.pageInfo.total = this.tableListAll.length
            this.tableList = this.tableListAll.sort(this.sortFun(column.prop, column.order === 'ascending'));
            // 回到第一页
            this.changePage(1);

        },
        sortFun (attr, rev) {
            //第一个参数传入info里的prop表示排的是哪一列，第二个参数是升还是降排序
            if (rev == undefined) {
                rev = 1;
            } else {
                rev = (rev) ? 1 : -1;
            }
            return function (a, b) {
                a = a[attr];
                b = b[attr];
                if (a < b) {
                    return rev * -1;
                }
                if (a > b) {
                    return rev * 1;
                }
                return 0;
            }
        },
        supportChange(val){
            this.supportValue = val
            // this.getInfo()
        },
        editionChange(val){
            this.jiaoYao = val
            // this.getInfo()
        },
        believeChange(val){
            this.believeValue = val
            // this.getInfo()
        },
        showSeeksGraph() {
            const __graph_json_data = {
                rootId: 'a',
                nodes:this.nodes,
                lines:this.linkArr, 
            } 
            // 以上数据中的node和link可以参考"Node节点"和"Link关系"中的参数进行配置 
            this.$refs.seeksRelationGraph.setJsonData(__graph_json_data, (seeksRGGraph) => {  
                // let relMapCcanvas = document.getElementsByClassName('rel-map-canvas')[0];
                // html2Canvas(this.$refs.d3Info,{
                //     useCORS: true
                // }).then(res=>{
                //     // console.log(res)
                //     this.reportImg = res.toDataURL('image/png');
                //     console.log(this.reportImg)
                // })
            })
            
        },
        onNodeClick(nodeObject, $event) {
            const allLinks = this.$refs.seeksRelationGraph.getLinks();
            allLinks.forEach((link) => {
                // 还原所有样式
                link.relations.forEach((line) => {
                if (line.data.orignColor) {
                    line.color = '#888'
                }
                if (line.data.orignFontColor) {
                    line.fontColor = '#888'
                }
                if (line.data.orignLineWidth) {
                    line.lineWidth = 1;
                    line.color = '#dddddd'
                }
                });
            });
            // 让与{nodeObject}相关的所有连线高亮
            allLinks .filter(
                (link) => link.fromNode === nodeObject || link.toNode === nodeObject ).forEach((link) => {
                    link.relations.forEach((line) => {
                        line.color = '#ff0000';
                        line.data.orignColor = line.color;
                        line.data.orignFontColor = line.fontColor || line.color;
                        line.data.orignLineWidth = line.lineWidth || 1;
                        line.fontColor = '#ff0000';
                        line.lineWidth = 3;
                    });
                });
            // 有时候更改一些属性后，并不能马上同步到视图，这需要以下方法让视图强制根据数据同步到最新
            this.$refs.seeksRelationGraph.getInstance().dataUpdated();
        },
        onLineClick(lineObject, $event) {
            // console.log('onLineClick:', lineObject)
        },
        report(){
            let d3DIV = document.getElementById('d3DIV');
            let _this = this
            domtoimage.toPng(d3DIV).then(function (dataUrl) {
                console.log(dataUrl)
                _this.reportImg = dataUrl;
                _this.isShowReport = true;
            }).catch(function (error) {
                console.error('生成失败', error);
                _this.$message.error('生成图片失败～');
            });
           
        }, 
    }
}
</script>

<style lang="less" scoped>
@import url('./analysis_details.less');
</style>
 